module.exports={
	"Hash": "nostalgia",
	"Name": "Nostalgia",
	"Version": "1.0.0",
	"Description": "Windows 9x: silver chrome, navy title bars and Tahoma in the light; a dim grey scheme in the dark.",
	"Comprehensive": true,
	"Modes": {
		"Strategy": "system",
		"Default": "light"
	},
	"Tokens": {
		"Color": {
			"Background": {
				"Primary": {
					"Light": "#c0c0c0",
					"Dark": "#3a3a3a"
				},
				"Secondary": {
					"Light": "#c0c0c0",
					"Dark": "#3a3a3a"
				},
				"Tertiary": {
					"Light": "#b8b8b8",
					"Dark": "#444444"
				},
				"Panel": {
					"Light": "#ffffff",
					"Dark": "#2a2a2a"
				},
				"Hover": {
					"Light": "#d4d0c8",
					"Dark": "#4a4a4a"
				},
				"Selected": {
					"Light": "#aab7d6",
					"Dark": "#34527d"
				}
			},
			"Text": {
				"Primary": {
					"Light": "#000000",
					"Dark": "#e6e6e6"
				},
				"Secondary": {
					"Light": "#1a1a1a",
					"Dark": "#cccccc"
				},
				"Muted": {
					"Light": "#404040",
					"Dark": "#a0a0a0"
				},
				"Placeholder": {
					"Light": "#707070",
					"Dark": "#7a7a7a"
				},
				"OnBrand": {
					"Light": "#ffffff",
					"Dark": "#ffffff"
				}
			},
			"Brand": {
				"Primary": {
					"Light": "#000080",
					"Dark": "#3a6ea5"
				},
				"PrimaryHover": {
					"Light": "#1066b3",
					"Dark": "#4a82c0"
				},
				"Accent": {
					"Light": "#000080",
					"Dark": "#7aa6e6"
				}
			},
			"Border": {
				"Light": "#808080",
				"Dark": "#202020"
			},
			"Status": {
				"Success": {
					"Light": "#008000",
					"Dark": "#2e7d32"
				},
				"Warning": {
					"Light": "#808000",
					"Dark": "#9a8a00"
				},
				"Error": {
					"Light": "#aa0000",
					"Dark": "#b03030"
				},
				"Info": {
					"Light": "#000080",
					"Dark": "#3a6ea5"
				}
			},
			"Scrollbar": {
				"Track": {
					"Light": "#c0c0c0",
					"Dark": "#3a3a3a"
				},
				"Thumb": {
					"Light": "#808080",
					"Dark": "#202020"
				},
				"Hover": {
					"Light": "#404040",
					"Dark": "#a0a0a0"
				}
			},
			"Selection": {
				"Background": {
					"Light": "#000080",
					"Dark": "#0a246a"
				},
				"Text": {
					"Light": "#ffffff",
					"Dark": "#ffffff"
				}
			},
			"Focus": {
				"Outline": {
					"Light": "#000080",
					"Dark": "#3a6ea5"
				}
			},
			"Shadow": {
				"Color": {
					"Light": "rgba(0,0,0,0.12)",
					"Dark": "rgba(0,0,0,0.40)"
				}
			}
		}
	},
	"Brand": {
		"Name": "Plansheet",
		"Tagline": "Everything, drafted."
	}
}
